export const state = () => ({
	plans: [],
})

export const actions = {
	async list({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/plans/`)
			.then((res) => {
				commit('setPlans', { data: res })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async completeCheckout(_, { companyId, appSubscriptionId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/plans/checkout-complete/`, {
			app_subscription_id: appSubscriptionId,
		})
	},

	async changePlan(_, { companyId, planId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/plans/change-plan/`, {
			method: 'POST',
			body: {
				plan_id: planId,
			},
		})
	},

	async livePortal(_, { companyId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/plans/live-portal/`)
	},
}

export const mutations = {
	setPlans(state, { data }) {
		state.plans = data
	},
}
